import { promptVars } from '../variables';
import { structureWithSchemaBasePrompt, } from './structureBasePrompt';
export const generateStructurePreviewsPrompt = structureWithSchemaBasePrompt
    .temp(0.5)
    .human('Give me a structure of the application.')
    .ai(promptVars.structureDsl)
    .human('Create previews with fields for all views in the structure. Make sure the previews are correct and show the data as expected. Connect the previews to selects and relation columns.');
//# sourceMappingURL=generateStructurePreviewsPrompt.js.map